import { View } from "binder"
import { FormBuilderComponentView, FormBuilderElement } from "src/formBuilder/structure/element";
import { LoadingViewModel } from "./loading-viewModel"

export class LoadingView extends FormBuilderComponentView<LoadingViewModel>{
    GetViewUniqueId(): string {
        return "V-4D683F25-E12C-499D-BFC1-C64509D7BE60"
    }
    loadHtml(): string {
        let element = require('./loading.html').default;
        let style = require('./loading.less');
        return element;
    }
    constructor() {
       super();
    }

    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;
    public set IsLoading(v: boolean) { this._IsLoading = v; } public get IsLoading(): boolean { return this._IsLoading;} private _IsLoading: boolean;

}
